import { Countries, PublicHolidays } from "@gemma/utils";

import { HighlightedDates } from "./HighlightedDates";

export function getHighlightedDates({ includeWeekends = true }: { includeWeekends?: boolean } = {}): HighlightedDates {
  const highlighted: HighlightedDates = { days: includeWeekends ? [6, 0] : [], dates: [] };

  const calendarDates = PublicHolidays.getByCountry(Countries.EnglandWales);
  for (const calendarDate of calendarDates) {
    highlighted.dates.push(calendarDate.asDate);
  }
  return highlighted;
}
